import { SystemLayerKey } from '@packages/database/types';

export type PresentationMode = 'card' | 'modal' | 'form' | 'none' | 'popup';

export interface FeatureBehavior {
  layerKey: SystemLayerKey | string;
  presentation: PresentationMode;
  urlParam?: 'ticketId' | 'assetId';
  dialogKey?: 'edit-ticket' | 'view-asset';
  shouldHighlight: boolean;
  shouldZoom: boolean;
  zoomLevel?: number;
  viewDetailsButton?: boolean;
}

export const FEATURE_REGISTRY: Record<string, FeatureBehavior> = {
  [SystemLayerKey.TICKET]: {
    layerKey: SystemLayerKey.TICKET,
    presentation: 'form', // Tickets use Dialogs, not popups
    urlParam: 'ticketId',
    dialogKey: 'edit-ticket',
    shouldHighlight: true,
    shouldZoom: true,
    viewDetailsButton: true,
  },
  [SystemLayerKey.ASSET]: {
    layerKey: SystemLayerKey.ASSET,
    presentation: 'modal',
    urlParam: 'assetId',
    shouldHighlight: true,
    shouldZoom: true,
    zoomLevel: 18,
    viewDetailsButton: true,
  },
  [SystemLayerKey.FIELD_NOTE]: {
    layerKey: SystemLayerKey.FIELD_NOTE,
    presentation: 'popup',
    shouldHighlight: true,
    shouldZoom: false,
  },
  [SystemLayerKey.SERVICE_AREA]: {
    layerKey: SystemLayerKey.SERVICE_AREA,
    presentation: 'card',
    shouldHighlight: true,
    shouldZoom: false,
  },
  [SystemLayerKey.PREMISE]: {
    layerKey: SystemLayerKey.PREMISE,
    presentation: 'card',
    shouldHighlight: true,
    shouldZoom: false,
  },
};

// Fallback for unknown layers
export const DEFAULT_BEHAVIOR: FeatureBehavior = {
  layerKey: 'GENERIC',
  presentation: 'none',
  shouldHighlight: false,
  shouldZoom: false,
};

export const getFeatureRegistry = (key: string): FeatureBehavior =>
  FEATURE_REGISTRY[key] || DEFAULT_BEHAVIOR;
